import * as React from 'react';
import './Main-page.scss';
import Promo from './promo/Promo';
import RoadMap from './road-map/Road-map';
import { useLocation } from 'react-router-dom';
import {useEffect, useState} from 'react';
import Social from '../shared/social/Social';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import poster1 from '../../assets/img/Image(1).png';
import poster2 from '../../assets/img/Image(2).png';
import poster3 from '../../assets/img/Image(3).png';
import poster4 from '../../assets/img/Image(4).png';
import poster5 from '../../assets/img/Image(5).png';
import poster6 from '../../assets/img/Image(6).png';
import config from "../../config";
import useWindowDimensions from "../../helpers/window";
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';

const Modal = require('react-bootstrap-modal')

const MainPage = () => {
  const { width } = useWindowDimensions();
  const [dialog, setDialog] = useState(false);
  const location = useLocation();
  const eventTrack = (action: string) => {
    window.gtag('event', action, { 'event_name': action })
  }

  useEffect(() => {
    const { hash } = location;

    const removeHash = () => {
      window.history.replaceState("", document.title, window.location.pathname
        + window.location.search);
    }

    const scroll = (id: string) => {
      window.scrollTo({
        behavior: 'smooth',
        top:
        // @ts-ignore
          document.getElementById(id.split('#')[1]).getBoundingClientRect().top -
          document.body.getBoundingClientRect().top
      });

      removeHash();
    };


    if (hash) {
      scroll(hash);
    }
  },[location]);

  const openDialog = (): void => {
    setDialog(true);
  }

  const closeDialog = (): void => {
    setDialog(false);
  }

  let centeredSlides: boolean = false;
  let initialSlide: number = 0;
  let spaceBetween: number = 34;

  // if (width < 1520) {
  //   centeredSlides = true
  //   initialSlide = 3;
  // }

  if (width < 768) {
    spaceBetween = 32;
  }

  return (
    <React.Fragment>
      <Promo/>

      <div className="submit-block">
        <div className="submit-block__title">
          <h2>
            2022 <br/>COMPETITION <br/>IS NOW CLOSED
          </h2>
        </div>

        {/*<a href={config.adminPanel}*/}
        {/*   className="submit-block__link"*/}
        {/*   target="_blank"*/}
        {/*   rel="noreferrer"*/}
        {/*   onClick={eventTrack.bind(this, 'admin-link_click')}*/}
        {/*>*/}
        {/*  Submit here*/}
        {/*</a>*/}
      </div>

      <div className="competition-block" id="event">
        <h2 className="competition-block__title">
          THIS IS HOW THE COMPETITION
          <br/>
          IS GOING TO WORK
        </h2>

        <button
           className="competition-block__button"
           onClick={openDialog.bind(this)}
        />

      </div>

      <div id="roadmap">
        <RoadMap />
      </div>

      <div className="partner-block" id="event">
        <h2 className="partner-block__title">
          IN PARTNERSHIP WITH
        </h2>
        <div className="partner-block__logo">
          XRM MEDIA
        </div>

        <a href={config.xrm}
           className="partner-block__button"
           target="_blank"
           rel="noreferrer"
           onClick={eventTrack.bind(this, 'xrm-click')}
        >GO TO XRM MEDIA</a>
      </div>

      <div className="winners-block">
        <div className="winners-block__title">
          <h2>
            2021 winners
          </h2>
        </div>

        <Swiper
          className={"winners-block__posters " + (!centeredSlides ? "skip-margin" : "")}
          spaceBetween={spaceBetween}
          slidesPerView="auto"
          loop={false}
          autoplay={false}
          centeredSlides={centeredSlides}
          initialSlide={initialSlide}
        >
          <SwiperSlide>
            <a href="https://argomedia.page.link/Drifting-Student"
               target="_blank"
               rel="noreferrer"
             >
              <img src={poster1} alt="Bad assistant poster"/>
              <h4>DRIFTING</h4>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://argomedia.page.link/When-the-Moon-was-Gibbous-Student"
               target="_blank"
               rel="noreferrer"
            >
              <img src={poster2} alt="Bad assistant poster"/>
              <h4>WHEN THE MOON <br/>WAS GIBBOUS
              </h4>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://argomedia.page.link/A-Word-Away-Student"
               target="_blank"
               rel="noreferrer"
            >
              <img src={poster3} alt="Bad assistant poster"/>
              <h4>A WORD AWAY</h4>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://argomedia.page.link/Finding-Light-Student"
               target="_blank"
               rel="noreferrer"
            >
              <img src={poster4} alt="Bad assistant poster"/>
              <h4>FINDING LIGHT</h4>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://argomedia.page.link/Password-to-the-Student"
               target="_blank"
               rel="noreferrer"
            >
              <img src={poster5} alt="Bad assistant poster"/>
              <h4>PASSWORD TO THE <br/>*****</h4>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a href="https://argomedia.page.link/Ghazaal-Student"
               target="_blank"
               rel="noreferrer"
            >
              <img src={poster6} alt="Bad assistant poster"/>
              <h4>GHAZAAL</h4>
            </a>
          </SwiperSlide>

        </Swiper>

        <a className="watch-films-button"
           href={config.competition}
           onClick={eventTrack.bind(this, 'watch_competition_winners_click')}
        >Watch Films</a>
      </div>

      <div className="purpose-block">
        <div className="title">
          Argo is on a mission to bring together the largest community of filmmakers and empower storytellers worldwide.
        </div>

        {/*<div className="purpose-block__text">*/}
        {/*  Become part of &nbsp;<br/><span className="underlined">the filmmaker metaverse</span><br/>*/}
        {/*</div>*/}

        {/*<div className="scissor-divider">*/}
        {/*  <div className="hr"/>*/}
        {/*</div>*/}

        <footer>
          <Social/>
          <a href="https://web.watchargo.com/pdf/document/version/2020/terms-and-conditions-1-0.pdf"
             target="_blank" rel="noreferrer" className="link terms decorated-link">Terms of service</a>
        </footer>
      </div>

      <Modal
        show={dialog}
        onHide={closeDialog.bind(this)}
        aria-labelledby="ModalHeader"
      >
        <Modal.Header closeButton>
          <Modal.Title id='ModalHeader'>Competition Guidelines</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SimpleBar className="modal__scrollable">
            <div className="modal__row">
              <span className="modal__number">1</span>
              <span className="modal__text">By submitting your film, your film will be considered for all awards (Jury + Audience)</span>
            </div>
            <div className="modal__row">
              <span className="modal__number">2</span>
              <span className="modal__text">Submissions close on <b>October 31, 2022</b></span>
            </div>
            <div className="modal__row">
              <span className="modal__number">3</span>
              <span className="modal__text">Audience Award voting begins on <b>September 1, 2022</b></span>
            </div>
            <div className="modal__row">
              <span className="modal__number">4</span>
              <span className="modal__text">You must be a full-time undergraduate or graduate student or have graduated within the last 2 years</span>
            </div>
            <div className="modal__row">
              <span className="modal__number">5</span>
              <span className="modal__text">“Student Film Channel” is going live on <b>September 1</b>! If you submitted a film, You will get your access pass in your email</span>
            </div>
            <div className="modal__row">
              <span className="modal__number">6</span>
              <span className="modal__text">Only the winning films will be published on Argo following the competition</span>
            </div>
          </SimpleBar>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Dismiss className='modal__button'>Got it</Modal.Dismiss>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export default MainPage;
